import React from "react";
import sImg1 from "../../images/story/image-5.jpg";
import sImg2 from "../../images/story/image-6.jpg";
import sImg3 from "../../images/story/image-7.jpg";

import fshape from "../../images/story/flower.svg";

interface Story {
  sImg: string;
  title: string;
  description: string;
}

interface StorySection2Props {
  sClass?: string;
}

const Storys: Story[] = [
  {
    sImg: sImg1,
    title: "First Time We Met",
    description:
      "We met by chance at a coffee shop on a rainy afternoon. she was reading her favorite book, and I offered her the last available seat. What began as casual conversation quickly turned into hours of laughter neither of them expected.",
  },
  {
    sImg: sImg2,
    title: "Where Love Started",
    description:
      "We met by chance at a coffee shop on a rainy afternoon. she was reading her favorite book, and I offered her the last available seat. What began as casual conversation quickly turned into hours of laughter neither of them expected.",
  },
  {
    sImg: sImg3,
    title: "She Said Yes",
    description:
      "We met by chance at a coffee shop on a rainy afternoon. she was reading her favorite book, and I offered her the last available seat. What began as casual conversation quickly turned into hours of laughter neither of them expected.",
  },
];

const StorySection2: React.FC<StorySection2Props> = ({ sClass }) => {
  return (
    <section className={`wpo-story-section-s2 ${sClass || ""}`}>
      <div className="container-fluid">
        <div className="story-title">
          <h2 className="splittext-line">
            “Every love story is beautiful, but ours is my favorite.”
          </h2>
          <div className="flower-shape">
            <img src={fshape} alt="decorative flower" />
          </div>
        </div>
      </div>
      <div className="story-wrapper">
        {Storys.map((story, index) => (
          <div className="story-card story-item-upp" key={index}>
            <div className="image">
              <img src={story.sImg} alt={story.title} />
            </div>
            <div className="content">
              <div className="text">
                <div className="text-items">
                  <h2>{story.title}</h2>
                  <p>{story.description}</p>
                </div>
              </div>
              <div className="shape"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StorySection2;
